import { createContext } from 'react'

export const PassContext = createContext({})